<section class="section jobs" id='jobs'>
  <div class="container">
      <div class="section-box">
          <div class="about-title mb-5" data-aos="fade-up" data-aos-duration="1000">
              <h3 class="e-font section-title">
                  <span class='code-font n-section-title'>02.</span> {{"Experience.Title" | translate}}
              </h3>
          </div>
          <div class="jobs-tabs" data-aos="fade-up" data-aos-duration="1000">

            <ul ngbNav #nav="ngbNav" [(activeId)]="active" orientation="vertical" class="nav-tabs jobs-tabs">
             <!-- primera lista -->
             <li *ngFor="let experiencia of Experiencias; let i = index" [title]="experiencia.Tab" [ngbNavItem]="i">
              <a ngbNavLink [attr.aria-current]="i === 0 ? 'page' : null">{{experiencia?.tab}}</a>

                      <ng-template ngbNavContent>
                        <!-- titulo y tab -->
                        <h4 class='title-tab-content'>{{experiencia?.titulo}} | <span class="company-tab-content">{{experiencia?.tab}}</span></h4>
                        <!-- fecha -->
                        <h5 class="job-time">{{experiencia?.fecha}}</h5>

                        <!-- {{job.Description | json}} segunda lista -->
                        <p>{{experiencia?.description}}</p>

                        <span></span>
                      </ng-template>
                  </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="mt-2"></div>
          </div>

      </div>
  </div>
</section>
